<template>
  <div class="card" v-if="penaltyDashboardData.rdy">
    <div class="card-header d-flex justify-content-between">
      <h6 class="mg-b-0">Батлагдсан торгуулийн тоо</h6>
      <nav class="nav nav-row-xs align-items-center">
        <a
          @click="
            penaltyDashboardData.params.mode = 1;
            loadDashboardData();
          "
          :class="
            `nav-link ${penaltyDashboardData.params.mode == 1 ? 'active' : ''}`
          "
          role="button"
          >1D</a
        >
        <a
          @click="
            penaltyDashboardData.params.mode = 2;
            loadDashboardData();
          "
          :class="
            `nav-link ${penaltyDashboardData.params.mode == 2 ? 'active' : ''}`
          "
          role="button"
          >1W</a
        >
        <a
          @click="
            penaltyDashboardData.params.mode = 3;
            loadDashboardData();
          "
          :class="
            `nav-link ${penaltyDashboardData.params.mode == 3 ? 'active' : ''}`
          "
          role="button"
          >1M</a
        >
        <a
          @click="
            penaltyDashboardData.params.mode = 4;
            loadDashboardData();
          "
          :class="
            `nav-link ${penaltyDashboardData.params.mode == 4 ? 'active' : ''}`
          "
          role="button"
          >1Y</a
        >
      </nav>
    </div>
    <div class="card-body">

      <div class="d-flex align-items-center text-center">
                  <div
                    class="profile-skillset flex-fill"
                  >
                    <h5>
                      <a class="link-01">{{ Number((penaltyDashboardData.data.list).reduce((sum, { count }) => sum + count, 0)).toLocaleString() }}</a>
                    </h5>
                    <label>Нийт</label>
                  </div>
                </div>

      <apexchart
        type="donut"
        height="350"
        :options="chartOptions"
        :series="series"
        :key="chartKey"
      ></apexchart>


      <ul id="iuasy2" class="list-group list-group-flush mg-b-0 tx-13 collapse ">
        <li
          @click="
            pnlt.show = !pnlt.show;
            reloadData();
          "
          class="list-group-item pd-x-0 d-flex justify-content-between"
          v-for="(pnlt, i) in penaltyDashboardData.data.list"
          :key="i"
          role="button"
        >
          <div class="tx-medium">
            <div
              style="float: left; margin-top: 4px; margin-right: 4px;"              :class="
                `wd-10 ht-10 ${
                  pnlt.show ? 'bg-primary' : 'bg-light'
                } rounded-circle pos-relative t--1`
              "
            ></div>
            {{ pnlt.pnltTypeTask }}
          </div>
          <span class="tx-rubik">{{ pnlt.count }}</span>
        </li>
      </ul>

      <a class="btn btn-info btn-xs" data-toggle="collapse" href="#iuasy2" role="button" aria-expanded="false" aria-controls="iuasy2">Дэлгэрэнгүй</a>
    </div>
    <div class="card-footer tx-11 tx-color-03 d-flex justify-content-between">
      <div>
        Хамрах хугацаа:
        {{
          penaltyDashboardData.data.processed.startDate | moment("YYYY.MM.DD")
        }}
        -
        {{ penaltyDashboardData.data.processed.endDate | moment("YYYY.MM.DD")
        }}<br />
        Боловсруулсан:
        {{ penaltyDashboardData.data.processed.time.toFixed(2) }}сек
      </div>
      <div class="mg-l-auto">
        <a @click="filterDateObj.mdl= true;" class="btn btn-primary">
          <feather type="filter"></feather>
          Огноо
        </a>
      </div>
    </div>
    <filter-date @do-search="doSearch" :mdl="filterDateObj.mdl" @on-hide="filterDateObj.mdl= false"></filter-date>

  </div>
</template>

<script>
// import "element-ui/lib/theme-chalk/index.css";
// import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";

const moment = require("moment");
import { request } from "@/api/all";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    apexchart: VueApexCharts,
    filterDate: () => ({
      component: import("@/views/apps/penalty/components/filterDate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),

  },
  data() {
    return {
      filterDateObj: {
        mdl: false,
        d1: null,
        d2: null
      },

      chartKey: 0,
      series: [
        // {
        //   data: [],
        // },
      ],
      chartOptions: {
        labels: [],
        legend: {
          show: false,
        },
        chart: {
          height: 350,
          type: "donut",
        },
        title: {
          text: "",
        },
      },
      penaltyDashboardData: {
        rdy: 0,
        params: {
          mode: 2,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          list: [],
          processed: {
            time: 0,
            startDate: "",
            endDate: "",
          },
        },
      },
    };
  },
  mounted() {
    this.loadDashboardData();
  },
  methods: {
    doSearch(e){
      this.penaltyDashboardData.params.startDate= e.d1;
      this.penaltyDashboardData.params.endDate= e.d2;
      this.penaltyDashboardData.params.mode= 0;
      this.loadDashboardData();
    },

    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    reloadData() {
      // this.series = this.penaltyDashboardData.data.list
      //   .filter((x) => x.show == true)
      //   .map((item) => {
      //     return { x: item.pnltTypeTask, y: item.count };
      //   });
      this.chartOptions.labels = this.penaltyDashboardData.data.list
        .filter((x) => x.show == true)
        .map((item) => {
          return  item.pnltTypeTask ;
        });
        this.series = this.penaltyDashboardData.data.list
        .filter((x) => x.show == true)
        .map((item) => {
          return  item.count ;
        });
      this.chartKey++;
    },
    loadDashboardData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "TrafficData/PenaltyGroupByType" },
        params: {
          mode: this.penaltyDashboardData.params.mode,
          startDate: this.penaltyDashboardData.params.startDate,
          endDate: this.penaltyDashboardData.params.endDate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.penaltyDashboardData.data = res.data;

          this.reloadData();

          this.penaltyDashboardData.rdy = true;
          //this.vehicleCountData.processed = res.data.processed
        }
      });
    },
  },
};
</script>
